import React, { FC } from 'react';

import { useRoutes } from 'src/explore/hooks/useRoutes';

export const SendAsGift: FC = () => {
  const routes = useRoutes();

  return (
    <div className="v2-cart__actions">
      <a
        href={routes.giftPurchase.root()}
        className="v2-form__btn v2-form__btn--outline btn-outline-secondary v2-form__btn--block py-3 px-6 mt-2 spec__send-as-gift-button"
      >
        Send as Gift
      </a>
    </div>
  );
};
